import type { UiArtGroup, ZoneId } from "@greg-chick/shared";

// 존 명칭은 **shared 한 곳**에 있다(zoneName.ts) — 관리자 집계 표와 같은 것을 써야 한다.
// 예전엔 여기와 관리자에 따로 적혀 있었고 조용히 갈렸다(관리자는 없는 구역 `library` 를 갖고
// 있어서 「도서관 2 · book 31」로 보였다). 여기서는 다시 내보내기만 한다.
export { ZONE_TITLE } from "@greg-chick/shared";

// 하단 바로가기 바 순서·아이콘(목업 하단 메뉴).
// ⚠️ 아이콘은 **랜딩 하단 7메뉴와 같은 것**을 쓴다 — 같은 곳이 화면마다 다른 그림이면
//    아이가 헷갈린다. 특히 예전엔 🎁 가 랜딩에선 '이벤트', 월드에선 '굿즈'로 뜻이 달랐다.
// 🧩 2026-09-27 — 그림 아이콘(`art`). 도서관·이벤트·굿즈는 **첫 화면 아래 메뉴 그림 그대로**(같은 곳 = 같은 그림).
//    그림을 못 받으면 `icon`(이모지)로 — UiIcon 이 알아서 내려간다.
export const TRAVEL_TABS: {
  zone: ZoneId;
  label: string;
  icon: string;
  art: readonly [UiArtGroup, string];
  feature?: string;
}[] = [
  { zone: "lobby", label: "마을", icon: "🏡", art: ["act", "village"] }, // 랜딩엔 대응 없음(월드 안의 허브)
  { zone: "book", label: "도서관", icon: "📚", art: ["nav", "library"] },
  { zone: "gyeongju", label: "경주", icon: "🏯", art: ["act", "gyeongju"] }, // 랜딩 ⭐(체험존)는 '월드 입장'이라 다른 뜻
  { zone: "event", label: "이벤트", icon: "🎁", art: ["nav", "event"] },
  /**
   * 🔴 **첫 화면에서 숨긴 굿즈를 여기서 걸어서 갔다**(2026-09-23 실측).
   * 영유아 모드인데 이 칸이 그대로 있었다 — 숨기기가 한 화면에서만 걸리면 다른 길이
   * 열려 있다. 판정은 `shared` 한 곳이고, 여기는 **어느 칸이 어느 열쇠인지**만 적는다.
   */
  { zone: "goods", label: "굿즈", icon: "🛍️", art: ["nav", "store"], feature: "world.zone.store" },
];

/** 미션(별 모으기) 대상 존과 존당 별 개수. */
export const STAR_ZONES: ZoneId[] = ["lobby", "book", "gyeongju", "goods", "event"];
export const STARS_PER_ZONE = 3;
